module.exports = __webpack_public_path__ + "img/completedonboard.63787865.svg";